import React, { createContext, useContext, useState, useEffect } from 'react';
import { 
  setAuthToken, 
  getAuthToken, 
  setUserData, 
  getUserData, 
  clearAuthData,
  isAuthenticated,
  getUserId,
  getOuId
} from '../shared/utils/authStorage';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  // Check authentication status on mount
  useEffect(() => {
    checkAuthStatus();
  }, []);

  const checkAuthStatus = () => {
    try {
      const token = getAuthToken();
      const userData = getUserData();
      
      console.log('Checking auth status:', { token: !!token, userData: !!userData });

      if (token) {
        setUser(userData);
        setIsAuth(true);
      } else {
        setUser(null);
        setIsAuth(false);
      }
    } catch (error) {
      console.error('Error checking auth status:', error);
      setUser(null);
      setIsAuth(false);
    } finally {
      setLoading(false);
    }
  };

  const login = async (token, userData) => {
    try {
      setAuthToken(token);
      if (userData) {
        setUserData(userData);
        setUser(userData);
      }
      setIsAuth(true);
      return true;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const logout = () => {
    clearAuthData();
    setUser(null);
    setIsAuth(false);
  };

  const updateUser = (newUserData) => {
    setUserData(newUserData);
    setUser(newUserData);
  };

  const value = {
    user,
    isAuth,
    loading,
    login,
    logout,
    updateUser,
    checkAuthStatus,
    getUserId,
    getOuId,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};